// module exports must be returned from runtime so entry inlining is disabled
// startup
// Load entry module and return exports
return __webpack_require__(44);
